import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import HeaderLogged from "components/Header/HeaderLogged";
import Header from "components/Header/Header";
import { AuthContext } from "../context/authContext";
import MainNav2 from "components/Header/MainNav2";

const SiteHeader = () => {
  const { currentUser } = useContext(AuthContext);

  return currentUser !== null ? <HeaderLogged /> : <MainNav2 />;
};

export default SiteHeader;
